import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <div className="error-boundary-icon">!</div>
            <h3>Une erreur inattendue est survenue</h3>
            <p className="text-muted">
              L'application a rencontre un probleme. Vous pouvez essayer de recharger cette section ou revenir a l'accueil.
            </p>
            {this.state.error && (
              <details className="error-boundary-details">
                <summary>Details techniques</summary>
                <pre>{this.state.error.toString()}</pre>
              </details>
            )}
            <div className="d-flex gap-2 justify-content-center mt-3">
              <button className="btn btn-outline-secondary btn-sm" onClick={this.handleReset}>
                Reessayer
              </button>
              <button className="btn btn-primary btn-sm" onClick={this.handleGoHome}>
                Retour a l'accueil
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
